import React from 'react'
import facebook from './svgs/editCircleIcon.svg'
import { BaseIcon } from './_base'

export const EditCircleIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {facebook} {...{fontSize,size,...sx}} />
    )
}
